import React from 'react';
import { ShoppingBag, DollarSign, Clock, Banknote, ArrowUpRight, ArrowDownRight } from 'lucide-react';
import { formatCompact } from './homeConfig';

const Trend = ({ value }) => {
  if (value === null || value === undefined) return <span className="text-xs text-slate-400">vs last month</span>;
  const up = value >= 0;
  const Icon = up ? ArrowUpRight : ArrowDownRight;
  return (
    <span className={`inline-flex items-center gap-0.5 text-xs font-medium ${up ? 'text-emerald-600' : 'text-red-600'}`}>
      <Icon className="w-3.5 h-3.5" />{Math.abs(value)}% MoM
    </span>
  );
};

const KpiCards = ({ kpis, loading }) => {
  const cards = [
    { id: 'orders', testid: 'kpi-card-orders', label: 'Total Sales Orders', value: kpis.totalOrders, icon: ShoppingBag, sub: <span className="text-xs text-slate-400">All time</span> },
    { id: 'revenue', testid: 'kpi-card-revenue', label: 'Revenue (YTD)', value: formatCompact(kpis.revenue), icon: DollarSign, sub: <Trend value={kpis.revenueTrend} /> },
    { id: 'pending', testid: 'kpi-card-pending', label: 'Pending Actions', value: kpis.pendingActions, icon: Clock, sub: <span className="text-xs text-slate-400">Open SO + PO</span> },
    { id: 'ar', testid: 'kpi-card-ar', label: 'AR Outstanding', value: formatCompact(kpis.arOutstanding), icon: Banknote, sub: <span className="text-xs text-slate-400">Open receivables</span> },
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {cards.map((c, i) => {
        const Icon = c.icon;
        return (
          <div
            key={c.id}
            data-testid={c.testid}
            className="bg-white border border-slate-200 rounded-lg p-5 hover:border-orange-300 transition-colors animate-in fade-in-0 slide-in-from-bottom-2"
            style={{ animationDelay: `${i * 60}ms`, animationFillMode: 'both' }}
          >
            <div className="flex items-center justify-between">
              <p className="text-sm text-slate-500">{c.label}</p>
              <span className="w-8 h-8 rounded-lg bg-orange-50 flex items-center justify-center">
                <Icon className="w-4 h-4 text-orange-600" strokeWidth={1.75} />
              </span>
            </div>
            <p className="text-2xl font-bold text-slate-900 mt-2 mb-1">
              {loading ? <span className="inline-block w-16 h-7 rounded bg-slate-100 animate-pulse" /> : c.value}
            </p>
            {!loading && c.sub}
          </div>
        );
      })}
    </div>
  );
};

export default KpiCards;
